import { useProfile } from 'Contexts/ProfileContext'
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import useLoggedNavigate from 'hooks/useLoggedNavigate'
export const AppSecurity: React.FC = () => {
  const location = useLocation()
  const navigate = useLoggedNavigate()
  const profileContext = useProfile()

  useEffect(() => {
    if (
      location.pathname.startsWith('/financials') &&
      profileContext.dependentData.userDetails.isFinancialRestricted
    ) {
      navigate('/')
    }
  }, [profileContext.dependentData.userDetails.isFinancialRestricted])

  return null
}
